// src/components/layout/JuniorHomeLanding.jsx
//
// R-TRAINING junior Cowork fix 3 (ruled 2026-11-04): A SIGNED-IN JUNIOR
// WHO OPENS `/` LANDS ON FROGGY U — not only at sign-in.
//
// `utils/juniorLanding.landingFor` ran only in Login.js, so a junior who
// was already signed in and opened the site's front door got the
// storefront. This runs the same reading (`juniorLandingPath`, the
// `froggy-u/` `landing` flag) on the app's FIRST route:
//   - only when that first route is exactly `/` — never a deep link, and
//     never an in-app walk to `/` (the storefront logo still reaches the
//     store);
//   - once per browser session (`froggerKeys.juniorLanded`, per user —
//     Login.js's landing sets it too), so a reload of the home page later
//     in the session stays on the home page;
//   - only while the keeper is still on `/` when the answer arrives;
//   - everyone who is not a junior is untouched (an Owner/Manager row or
//     two facilities never even asks).
//
// Rendered once, from App.js. Draws nothing.
import { useContext, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { getFroggyU } from '../../services/api';
import { userIdOf } from '../../utils/froggerStorageKeys';
import {
  juniorLandedThisSession, juniorLandingPath, markJuniorLanded,
} from '../../utils/juniorLanding';

export const HOME_PATH = '/';

export default function JuniorHomeLanding({ fetchFroggyU = getFroggyU }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const auth = useContext(AuthContext) || {};
  const userId = userIdOf(auth.user);
  // The app's FIRST route — read once, on the first render.
  const firstPathRef = useRef(pathname);
  // Where the keeper is NOW, for the answer that arrives later.
  const pathRef = useRef(pathname);
  pathRef.current = pathname;
  const triedRef = useRef(false);

  useEffect(() => {
    // Once for the app's life (StrictMode's second effect run included).
    if (triedRef.current) return;
    triedRef.current = true;
    if (firstPathRef.current !== HOME_PATH) return;
    if (userId === null || !auth.isAuthenticated) return;
    if (juniorLandedThisSession(userId)) return;
    juniorLandingPath(auth.roles, fetchFroggyU).then((path) => {
      if (!path || pathRef.current !== HOME_PATH) return;
      markJuniorLanded(userId);
      navigate(path, { replace: true });
    });
    // Read once, by design: the first route is the app's first route.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
